import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Location } from '@angular/common';
import { IUser } from '@shared/models/login.model';
import { UserService } from '@shared/services/user.service';
import { ToastCustomService } from '@shared/services/toast-custom.service';

@Injectable({
  providedIn: 'root'
})
export class RolesGuard implements CanActivate {
  private user: IUser;
  constructor(
    private location: Location,
    private router: Router,
    private userService: UserService,
    private ts: ToastCustomService
  ) {
    this.user = this.userService.userInfo;
  }
  canActivate(route: ActivatedRouteSnapshot): boolean {
    switch (route.data.action) {
      case 'redirect':
        const view = route.data.rules.filter(
          config => config.role == this.user.role.name
        );
//console.log("view : "+view[0].pathModule +" view ro "+view[0].view +);
        if (view.length > 0) {
          if (
            view[0].pathModule.indexOf('dashboard') != -1 &&
            window.location.pathname.indexOf('dashboard/') != -1
          ) {
            const url = window.location.pathname.split('/');
            this.router.navigate([
              '/main/' + view[0].pathModule + '/' + url[url.length - 1]
            ]);
          } else {
            this.router.navigate([
              '/main/' + view[0].pathModule + '/' + view[0].view
            ]);
          }
        } else {
          this.location.back();
        }
        break;

      default:
        const roles: [] = route.data.roles;
        // Validate access to modules without permission config
        if (roles && roles.length > 0) {
          return roles.filter(rol => rol == this.user.role.name).length > 0
            ? true
            : false;
        } else {
          // Validate access to modules with permission config
          const permissionModules = this.userService.userModulesInfo;
          const translateRoute = {
            'order-management': 'orders',
            companies: 'shippers'
          };
          const path = route.url && route.url[0].path;
          const moduleValidation =
            path && translateRoute[path] ? translateRoute[path] : path;
          if (
            permissionModules &&
            permissionModules[moduleValidation] &&
            Object.keys(permissionModules[moduleValidation])
          ) {
            if (!permissionModules[moduleValidation].active) {
              this.displayErrorMessage();
              setTimeout(() => {
                this.location.back();
              }, 500);
            }
            return permissionModules[moduleValidation].active;
          }
        }
        return true;
        break;
    }
  }

  private displayErrorMessage() {
    this.ts.show(
      'error',
      'You do not have access',
      'Request access to this resource from an administrator'
    );
  }
}
